module.exports = __webpack_public_path__ + "media/images/icon-dropdown-gray-66fd364d232156b2817c97652be8fffe.svg";